import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useAccount } from "wagmi";
export default function useWalletAccount() {
    const { address: evmAddress, connector, chainId } = useAccount();
    const networkFamily = useMemo(() => (connector?.type !== "orangekit" ? "evm" : "bitcoin"), [connector]);
    const { data: btcData } = useQuery({
        queryKey: [connector?.id],
        queryFn: async () => {
            const bitcoinProvider = connector.getBitcoinProvider();
            const address = await bitcoinProvider.getAddress();
            const balance = await bitcoinProvider.getBalance();
            return {
                address,
                balance,
            };
        },
    });
    const { address: btcAddress } = btcData || {};
    return {
        accountAddress: evmAddress,
        walletAddress: btcAddress ?? evmAddress,
        isConnected: networkFamily === "bitcoin" ? !!btcAddress : !!evmAddress,
        networkFamily,
        connector,
        chainId,
    };
}
//# sourceMappingURL=useWalletAccount.js.map